/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeInvestorCreditSplitPostRequestSchema } from './changeInvestorCreditSplitPostRequestSchema.ts';
import { changeInvestorCreditSplitPostResponseSchema } from './changeInvestorCreditSplitPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeInvestorCreditSplit200Schema = z.lazy(() => changeInvestorCreditSplitPostResponseSchema);

/**
 * @description 505 response
 */
export const postChangeInvestorCreditSplit505Schema = z.any();

export const postChangeInvestorCreditSplitMutationRequestSchema = z.lazy(
  () => changeInvestorCreditSplitPostRequestSchema
);

export const postChangeInvestorCreditSplitMutationResponseSchema = z.lazy(() => postChangeInvestorCreditSplit200Schema);
